/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratPillarInfo,
    JsonStratPillarInfoFromJSON,
    JsonStratPillarInfoFromJSONTyped,
    JsonStratPillarInfoToJSON,
} from './JsonStratPillarInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratPillarInfo
 */
export interface ApiResultOfJsonStratPillarInfo {
    /**
     * 
     * @type {JsonStratPillarInfo}
     * @memberof ApiResultOfJsonStratPillarInfo
     */
    data?: JsonStratPillarInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratPillarInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratPillarInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratPillarInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratPillarInfo
     */
    result?: ApiResultOfJsonStratPillarInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratPillarInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratPillarInfoFromJSON(json: any): ApiResultOfJsonStratPillarInfo {
    return ApiResultOfJsonStratPillarInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratPillarInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratPillarInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratPillarInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratPillarInfoToJSON(value?: ApiResultOfJsonStratPillarInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratPillarInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

